module.exports = __webpack_public_path__ + "static/media/boat-img-9.22015282.jpg";